import { observer } from 'mobx-react-lite';
import { Outlet, Navigate, useLocation } from 'react-router';
import { useStore } from '@sagano/agent/stores';

const PrivateRoute = observer(() => {
  const { auth } = useStore();
  const location = useLocation();
  if (auth.loggedIn) {
    return <Outlet />;
  } else {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
});

export default PrivateRoute;
